'use strict';

angular.module('app').factory('CorporateUsersService', CorporateUsersService);

CorporateUsersService.$inject = ['ApiService', 'utilService'];

function CorporateUsersService(ApiService, utilService) {
    return {
        getNumberOfCorporateUsers: function (entityId) {
            var url = utilService.getLoggedInUserData().role === 'SUPERUSER' ? 'api/super/corporate-entity/' + entityId + '/limits' : 'api/coach/corporate-entity/limits';

            return ApiService.get(url).then(function (res) {
                return res;
            }, function (err) {
                return err;
            });
        }
    };
}
